
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

interface ScriptureReference {
  reference: string;
  text: string;
  explanation?: string;
}

interface ScriptureReferencesSectionProps {
  scriptureReferences: ScriptureReference[];
}

const ScriptureReferencesSection: React.FC<ScriptureReferencesSectionProps> = ({ 
  scriptureReferences 
}) => {
  // Add better validation to ensure we have valid scripture references to display
  if (!Array.isArray(scriptureReferences) || scriptureReferences.length === 0) {
    console.log("No scripture references to display:", scriptureReferences);
    return null;
  }

  // Make sure each reference has the required fields
  const validReferences = scriptureReferences.filter(ref => 
    ref && typeof ref === 'object' && ref.reference && ref.text
  );

  if (validReferences.length === 0) {
    console.log("No valid scripture references found:", scriptureReferences);
    return null;
  }
  
  console.log("Displaying scripture references:", validReferences);

  return (
    <Card className="border-heaven-gold/10">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <ScrollText className="h-5 w-5 text-heaven-gold" />
          <span className="text-heaven-gold">Scripture References</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 text-left">
          {validReferences.map((reference, index) => (
            <div key={index} className="space-y-1 text-left">
              <h4 className="font-semibold text-gray-800 text-left">{reference.reference}</h4>
              <p className="text-gray-700 text-sm italic text-left">"{reference.text}"</p>
              {reference.explanation && (
                <p className="text-gray-600 text-sm text-left">{reference.explanation}</p>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ScriptureReferencesSection;
